"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestERC1271Wallet__factory = exports.IERC20Approve__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var IERC20Approve__factory_1 = require("./IERC20Approve__factory");
Object.defineProperty(exports, "IERC20Approve__factory", { enumerable: true, get: function () { return IERC20Approve__factory_1.IERC20Approve__factory; } });
var TestERC1271Wallet__factory_1 = require("./TestERC1271Wallet__factory");
Object.defineProperty(exports, "TestERC1271Wallet__factory", { enumerable: true, get: function () { return TestERC1271Wallet__factory_1.TestERC1271Wallet__factory; } });
//# sourceMappingURL=index.js.map